import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

const SurfaceTypeSelect = ({ value, onChange }) => {
  return (
    <Form.Group
      controlId="surfaceTypeSelect"
      className="d-flex align-items-center"
    >
      <Form.Label style={{ width: '100px' }}>Terrain:</Form.Label>
      <Form.Control
        as="select"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value="GRAVEL_PATH">Piste bitumée ou stabilisée</option>
        <option value="DIRT_PATH">Piste en terre ou herbe</option>
        <option value="SINGLETRACK">Sentier</option>
      </Form.Control>
    </Form.Group>
  )
}

SurfaceTypeSelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default SurfaceTypeSelect
